export default [
  { key: 'name', val: 'Name:' },
  { key: 'email', val: 'Email:' },
  { key: 'status', val: 'Status:' },
];
